export const STOCK_NUMBER_PERMISSIONS = 'Stock Number'
export const MACHINE_NUMBER_PERMISSIONS = 'Machine Number'

export const SERIAL_NUMBER = 'SERIAL NUMBER'
export const MACHINE_NUMBER = 'MACHINE NUMBER'
export const STOCK_NUMBER = 'STOCK NUMBER'
export const TYPE = 'TYPE'
export const MAKE = 'MAKE'
export const MODEL = 'MODEL'
export const CLASS = 'CLASS'
export const CAPACITY = 'CAPACITY'
export const LIP_WIDTH = 'LIP WIDTH'
export const MANUFACTURER = 'MANUFACTURER'

export const dashboardTableHeaders: string[] = [
    'tag_id',
    'serial_number',
    'stock_number',
    'machine_number',
    'make',
    'model',
    'class',
    'capacity',
    'lip_width',
    'manufacturer',
]

export const locationHistoryTableHeaders: string[] = [
    'created_at',
    'location_name',
]

export const keysToDelete: string[] = [
    'item_number',
    'created_at',
    'updated_at',
]

export const NON_ESCO = 'NON_ESCO'
export const POINTS = 'POINTS'
export const ADAPTERS = 'ADAPTERS'
export const OTHERS = 'OTHERS'
export const BILL_OF_MATERIAL = 'BILL_OF_MATERIALS'

export const ASSET_DATA = 'assetData'
export const SELECTED_ASSET = 'selectedAsset'
export const UNDEFINED = 'undefined'
export const NULL = 'null'

export enum GEOFENCE_SHAPE {
    CIRCLE = 'circle',
    POLYGON = 'polygon',
}

export enum TAG_TYPE {
    SATELLITE = 'satellite',
    BLUETOOTH = 'bluetooth',
    CELL_TOWER = 'cellular',
}

export const PRINT_PAGE_DIV_ID = 'attachment-data'
export const PRINT_PAGE_TITLE = 'Serial Look Up'
